export default {
  name: 'nodesISCSIDisks',
  namespaced: true,
  state: {
    disks: [],
    pending: false,
  },
  getters: {
    getDisks: state => state.disks || [],
    getPending: state => state.pending,
  },
  mutations: {
    SET_DISKS(state, payload) {
      state.disks = payload;
    },
    SET_PENDING(state, status) {
      state.pending = status;
    }
  },
  actions: {
    FETCH_ISCSI_DISKS({ commit }) {
      commit('SET_PENDING', true);

      return this.$api.get('/api/v2/iscsi-initiators/nodes-with-attached-disks/')
        .then((response) => {
          commit('SET_DISKS', response.data);
          return response;
        })
        .finally(() => {
          commit('SET_PENDING', false);
        });
    }
  }
};
